import React, { useState } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import "../../Placement.css";
import bannerImage from "../../Images/Banner/university.webp";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import classroomImage from "../../Images/gov-body/rules.webp";
import EnquiryNow from "../common/EnquiryNow";

// Company Logos
import company1 from "../../Images/companylogo2/Gujarat Ambuja Exports Limited 2.webp";
import company2 from "../../Images/companylogo2/aquaplast.webp";
import company3 from "../../Images/companylogo2/aurobindo.webp";
import company4 from "../../Images/companylogo2/dabur.webp";
import company5 from "../../Images/companylogo2/hira-logo1.webp";
import company6 from "../../Images/companylogo2/kalpataru.webp";
import company7 from "../../Images/companylogo2/nsdc.webp";
import company8 from "../../Images/companylogo2/securitylab.webp";
import company9 from "../../Images/companylogo2/tmc.webp";
import company10 from "../../Images/companylogo2/vrize.webp";
import company11 from "../../Images/companylogo2/apb_company.jfif";
import company12 from "../../Images/companylogo2/bsa_corporation_limited_company.jfif";
import company13 from "../../Images/companylogo2/chemfield_cellulose_logo.jfif";
import company14 from "../../Images/companylogo2/dbpower.jfif";
import company15 from "../../Images/companylogo2/digiSafari_company2.jfif";
import company16 from "../../Images/companylogo2/nitika.jfif";
import company17 from "../../Images/companylogo2/Struc_sompany4.jfif";
import company18 from "../../Images/companylogo2/tuliplab_logo.jfif";

const Recruiters = () => {
  const [modalShow2, setModalShow2] = useState(false);

  const cards = [
    {
      title: "Information Technology:",
      description:
        "We have partnerships with leading technology firms to provide our students with various roles in software development, data analytics, cybersecurity, and IT consultancy.",
    },
    {
      title: "Finance and Banking:",
      description:
        "We also have close links with financial institutions and banks that present the student with opportunities in investment banking, financial analysis, and risk management.",
    },
    {
      title: "Manufacturing and Engineering:",
      description:
        "We also partner with leading manufacturing firms to provide routes into production management, quality assurance, and indeed engineering roles for our students.",
    },
    {
      title: "Healthcare:",
      description:
        "Our close associations with healthcare organizations open up further opportunities for our students in health care management, pharmaceutical sales, and health information technology.",
    },
    {
      title: "Retail and E-commerce:",
      description:
        "Through connections with big-box retailers and leading e-commerce sites, students can participate in tasks surrounding supply chain management, marketing, and sales.",
    },
    {
      title: "Consulting:",
      description:
        "Our close links with consulting firms open up opportunities for our graduates in management consulting, business analysis, and strategic planning.",
    },
  ];

  const recruiters = [
    { name: "Gujarat Ambuja Exports Limited", logo: company1 },
    { name: "Aquaplast", logo: company2 },
    { name: "Aurobindo Pharma", logo: company3 },
    { name: "Dabur", logo: company4 },
    { name: "HIRA Group", logo: company5 },
    { name: "Kalpataru Power Transmission Ltd.", logo: company6 },
    { name: "NSDC (National Skill Development Corporation)", logo: company7 },
    { name: "Security Lab", logo: company8 },
    { name: "TMC (The Mandhana Consortium)", logo: company9 },
    { name: "Vrize", logo: company10 },
    { name: "APB Corporation", logo: company11 },
    { name: "BSA Corporation Limited", logo: company12 },
    { name: "Chemfield Cellulose", logo: company13 },
    { name: "DB Power", logo: company14 },
    { name: "DigiSafari", logo: company15 },
    { name: "Nitika Pharmaceuticals", logo: company16 },
    { name: "STRUC (Structural Solutions Company)", logo: company17 },
    { name: "Tulip Lab", logo: company18 },
  ];

  const recruiterSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 576, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <>
      <title>ISBM University Placements – Leading Companies Recruit Here</title>
      <meta
        name="description"
        content="ISBM University partners with top companies to offer students vast career opportunities. Explore our recruiter network and start your journey today."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="conatiner-xxl">
            <div className="section-hero-content">
              <h1>Recruiters</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li className="breadcrumb-item active text-white" aria-current="page">
                  Recruiters
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="container-xxl pt-5">
        <h2 className="text-center modern-title section-title text-blue">Recruiters</h2>
        <div className="row ptb-50 flex-wrap-reverse">
          <div className="col-md-6">
            <div className="governing-image-wrapper shadow">
              <img src={classroomImage} alt="Governing Body" />
            </div>
          </div>
          <div className="col-md-6">
            <p className="lead text-center mt-5">
              At ISBM University, we take pride in our strong connections with a
              wide array of esteemed companies and organizations that actively
              participate in our campus recruitment efforts. Our strong placement
              network helps to unlock a plethora of opportunities for our students
              while giving them valuable insight into various industries and job
              profiles.
            </p>
          </div>
        </div>
      </section>

      <section className="ptb-50 bg-new">
        <div className="container-xxl">
          <Row className="mt-5">
            <Col lg={12}>
              <div className="recruiters-section" data-aos="fade-up">
                <h2 className="modern-title">
                  Our Top <span>Recruiters</span>
                </h2>
                <p className="modern-subtitle">
                  We partner with industry leaders to provide exceptional opportunities
                </p>

                <Slider {...recruiterSettings} className="recruiters-slider">
                  {recruiters.map((recruiter, index) => (
                    <div className="recruiter-item" key={index}>
                      <div className="recruiter-logo-container">
                        <img
                          src={recruiter.logo}
                          alt={recruiter.name}
                          className="recruiter-logo"
                        />
                      </div>
                      <p className="recruiter-name">{recruiter.name}</p>
                    </div>
                  ))}
                </Slider>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section className="container-xxl ptb-50">
        <h2 className="text-center modern-title section-title text-blue">
          Diverse Industry Partnership
        </h2>
        <p className="lead text-center">
          We have established tie-ups with leading companies across multiple sectors, including
        </p>
        <div className="section-container mt-3">
          <EnquiryNow show={modalShow2} onHide={() => setModalShow2(false)} />
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
            {cards.map((card, index) => (
              <div className="col" key={index}>
                <div className="card-1 p-4 h-100 text-center text-lg-start rounded-3 shadow">
                  <h4>{card.title}</h4>
                  <div className="underline-divider mb-3"></div>
                  <p>{card.description}</p>
                  {card.button && (
                    <button
                      type="button"
                      className="btn btn-warning border fw-bold px-5 p-3"
                      onClick={() => setModalShow2(true)}
                    >
                      Apply Now
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Recruiters;
